
import React from 'react';
import { AlertCircle, RefreshCw, Home } from 'lucide-react';

class GlobalErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        // You can also log the error to an error reporting service
        console.error("GlobalErrorBoundary Catch:", error, errorInfo);
        this.setState({ errorInfo });
    }

    handleReload = () => {
        window.location.reload();
    };

    handleGoHome = () => {
        window.location.href = '/';
    };

    render() {
        if (this.state.hasError) {
            // Fallback UI
            return (
                <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4 font-sans">
                    <div className="max-w-md w-full bg-white rounded-2xl shadow-xl p-8 border border-gray-200">
                        <div className="text-center mb-6">
                            <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                                <AlertCircle className="w-8 h-8 text-red-600" />
                            </div>
                            <h2 className="text-2xl font-bold text-gray-800 mb-2">
                                Oops, Terjadi Kesalahan
                            </h2>
                            <p className="text-gray-600">
                                Maaf, aplikasi mengalami masalah yang tidak terduga. Kami telah mencatat error ini.
                            </p>
                        </div>

                        {/* Error Details (Only in Dev) */}
                        <div className="bg-gray-50 rounded-lg p-4 mb-6 text-left overflow-auto max-h-40 border border-gray-200">
                            <p className="text-xs font-mono text-red-600 break-words font-semibold mb-1">
                                {this.state.error && this.state.error.toString()}
                            </p>
                            <p className="text-xs font-mono text-gray-500 whitespace-pre-wrap">
                                {this.state.errorInfo && this.state.errorInfo.componentStack &&
                                    this.state.errorInfo.componentStack.split('\n')[1] // Just show first line of stack for cleanliness
                                }
                            </p>
                        </div>

                        <div className="flex flex-col gap-3">
                            <button
                                onClick={this.handleReload}
                                className="w-full bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-xl font-medium transition-colors flex items-center justify-center gap-2"
                            >
                                <RefreshCw size={18} />
                                Muat Ulang Halaman
                            </button>
                            <button
                                onClick={this.handleGoHome}
                                className="w-full bg-white hover:bg-gray-50 text-gray-700 border border-gray-300 py-3 rounded-xl font-medium transition-colors flex items-center justify-center gap-2"
                            >
                                <Home size={18} />
                                Kembali ke Beranda
                            </button>
                        </div>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

export default GlobalErrorBoundary;
